export default __webpack_public_path__ + "static/media/typewriter768.90da270e.jpg";